(function () {
  var hubSelector = '.kl-hub-modal-veil';
  var attachedHubs = new WeakSet();
  var activePanel = null;
  var lastTouchX = 0;
  var lastTouchY = 0;

  function markScrollablePanels(hub) {
    hub.querySelectorAll('*').forEach(function (element) {
      var style = window.getComputedStyle(element);
      var canScrollVertically =
        style.overflowY === 'auto' || style.overflowY === 'scroll';

      if (canScrollVertically) {
        element.setAttribute('data-scroll-lock-scrollable', '');
        element.setAttribute('data-klaviyo-hub-scrollable', '');
      }
    });
  }

  function isVisibleVerticalScroller(element) {
    if (!(element instanceof Element)) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return (
      rect.width > 0 &&
      rect.height > 0 &&
      (style.overflowY === 'auto' || style.overflowY === 'scroll') &&
      element.scrollHeight > element.clientHeight + 2
    );
  }

  function findTouchPanel(target, hub) {
    var element = target instanceof Element ? target : null;
    while (element && element !== hub) {
      if (isVisibleVerticalScroller(element)) return element;
      element = element.parentElement;
    }

    var candidates = Array.prototype.filter.call(
      hub.querySelectorAll('[data-klaviyo-hub-scrollable]'),
      isVisibleVerticalScroller
    );
    candidates.sort(function (left, right) {
      return (
        right.scrollHeight - right.clientHeight -
        (left.scrollHeight - left.clientHeight)
      );
    });
    return candidates[0] || null;
  }

  function onTouchStart(event) {
    if (event.touches.length !== 1) return;
    var target = event.target instanceof Element ? event.target : null;
    var hub = target && target.closest(hubSelector);
    if (!hub) return;

    markScrollablePanels(hub);
    activePanel = findTouchPanel(target, hub);
    lastTouchX = event.touches[0].clientX;
    lastTouchY = event.touches[0].clientY;
  }

  function onTouchMove(event) {
    if (!activePanel || event.touches.length !== 1) return;

    var currentX = event.touches[0].clientX;
    var currentY = event.touches[0].clientY;
    var deltaX = lastTouchX - currentX;
    var deltaY = lastTouchY - currentY;
    lastTouchX = currentX;
    lastTouchY = currentY;

    if (Math.abs(deltaY) <= Math.abs(deltaX)) return;

    var maxScrollTop = activePanel.scrollHeight - activePanel.clientHeight;
    var nextScrollTop = Math.max(
      0,
      Math.min(maxScrollTop, activePanel.scrollTop + deltaY)
    );
    if (nextScrollTop === activePanel.scrollTop) return;

    activePanel.scrollTop = nextScrollTop;
    if (event.cancelable) event.preventDefault();
    event.stopImmediatePropagation();
  }

  function clearTouchPanel() {
    activePanel = null;
  }

  function attachHub(hub) {
    if (!hub || attachedHubs.has(hub)) return;
    attachedHubs.add(hub);

    var updatePending = false;
    var update = function () {
      if (updatePending) return;
      updatePending = true;
      window.requestAnimationFrame(function () {
        updatePending = false;
        markScrollablePanels(hub);
      });
    };

    new MutationObserver(update).observe(hub, {
      childList: true,
      subtree: true,
    });

    update();
    window.setTimeout(update, 250);
    window.setTimeout(update, 1000);
  }

  function findHub(node) {
    if (!(node instanceof Element)) return;
    if (node.matches(hubSelector)) attachHub(node);
    node.querySelectorAll(hubSelector).forEach(attachHub);
  }

  function start() {
    document.querySelectorAll(hubSelector).forEach(attachHub);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(findHub);
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
    });

    document.addEventListener('touchstart', onTouchStart, {
      capture: true,
      passive: true,
    });
    document.addEventListener('touchmove', onTouchMove, {
      capture: true,
      passive: false,
    });
    document.addEventListener('touchend', clearTouchPanel, {
      capture: true,
      passive: true,
    });
    document.addEventListener('touchcancel', clearTouchPanel, {
      capture: true,
      passive: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
